"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));

var _constants = require("../constants");

/**
 * @class RechabilityRequest
 */
var RechabilityRequest = /*#__PURE__*/(0, _createClass2.default)(
/**
 * Creates an instance of RechabilityRequest.
 * @param {object} webex
 * @memberof RechabilityRequest
 */
function RechabilityRequest(webex) {
  var _this = this;

  (0, _classCallCheck2.default)(this, RechabilityRequest);
  (0, _defineProperty2.default)(this, "getClusters", function () {
    return _this.webex.request({
      method: _constants.HTTP_VERBS.GET,
      shouldRefreshAccessToken: false,
      api: _constants.API.CALLIOPEDISCOVERY,
      resource: _constants.RESOURCE.CLUSTERS
    }).then(function (res) {
      var clusters = res.body.clusters;

      _loggerProxy.default.logger.log("Reachability:request#getClusters --> get clusters successful:".concat((0, _stringify.default)(clusters)));

      return clusters;
    });
  });
  (0, _defineProperty2.default)(this, "remoteSDPForClusters", function (localSDPList) {
    return _this.webex.request({
      method: _constants.HTTP_VERBS.POST,
      shouldRefreshAccessToken: false,
      api: _constants.API.CALLIOPEDISCOVERY,
      resource: _constants.RESOURCE.REACHABILITY,
      body: {
        offers: localSDPList
      }
    }).then(function (res) {
      _loggerProxy.default.logger.log('Reachability:request#remoteSDPForClusters --> Remote SDPs got succcessfully');

      return res.body;
    });
  });
  this.webex = webex;
}
/**
 * gets the cluster information
 * @returns {Promise}
 */
);
var _default = RechabilityRequest;
exports.default = _default;
//# sourceMappingURL=request.js.map
